import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu menu-sub menu-sub-dropdown w-250px min-w-md-300px max-w-md-300px dropdown-menu show",
  "aria-labelledby": "dropdownMenuButton",
  "data-kt-menu": "true",
  id: "filter-dropdown"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter Options")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "form-label fw-bold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "btn-group w-100",
  "data-kt-buttons": "true",
  "data-kt-buttons-target": "[data-kt-button]"
}
const _hoisted_9 = ["name", "onChange", "id"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["name", "id", "onChange"]
const _hoisted_12 = ["for"]
const _hoisted_13 = ["name", "id", "onChange"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  class: "btn-group w-100",
  "data-kt-buttons": "true",
  "data-kt-buttons-target": "[data-kt-button]"
}
const _hoisted_17 = ["name", "onChange", "checked", "id", "value"]
const _hoisted_18 = ["for"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectElement = _resolveComponent("MultiselectElement")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_ctx.getFiltersMapping && _ctx.getFilterValues)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFiltersMapping, (filter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mb-10"
            }, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(filter.label), 1),
              _createElementVNode("div", null, [
                (
              filter.type == 'groupedSelect' &&
              _ctx.getDateForFilters &&
              _ctx.getFilterValues
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_MultiselectElement, {
                        object: true,
                        placeholder: 'Select ' + filter.label,
                        options: filter.mapping(_ctx.getDateForFilters[filter.name]),
                        search: true,
                        searchable: true,
                        "value-prop": "id",
                        label: "name",
                        ref_for: true,
                        ref: _ctx.filterRefs[filter.name],
                        onChange: ($event: any) => (_ctx.changeSelectValue($event, filter.name))
                      }, {
                        option: _withCtx(({ option }) => [
                          _createElementVNode("div", {
                            style: _normalizeStyle(
                    'padding-left: ' + parseInt(option.depth) * 10 + 'px;'
                  )
                          }, _toDisplayString(option.name), 5)
                        ]),
                        _: 2
                      }, 1032, ["placeholder", "options", "onChange"])
                    ]))
                  : (filter.type == 'radioButton')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _createElementVNode("input", {
                              class: "btn-check",
                              type: "radio",
                              name: 'radio' + filter.name,
                              onChange: ($event: any) => (_ctx.changeCheckBoxValue($event, null, filter.name)),
                              checked: "checked",
                              ref_for: true,
                              ref: _ctx.filterRefs[filter.name],
                              id: filter.name + '-all',
                              value: "1"
                            }, null, 40, _hoisted_9),
                            _createElementVNode("label", {
                              class: "btn filter-chip",
                              for: filter.name + '-all'
                            }, " All", 8, _hoisted_10)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("input", {
                              class: "btn-check",
                              type: "radio",
                              name: 'radio' + filter.name,
                              id: filter.name + '-posValue',
                              ref_for: true,
                              ref: _ctx.filterRefs[filter.name],
                              onChange: ($event: any) => (
                  _ctx.changeCheckBoxValue(
                    $event,
                    filter.attributes.posValue,
                    filter.name
                  )
                ),
                              value: "2"
                            }, null, 40, _hoisted_11),
                            _createElementVNode("label", {
                              class: "btn filter-chip",
                              for: filter.name + '-posValue'
                            }, _toDisplayString(filter.attributes.posValue), 9, _hoisted_12)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("input", {
                              class: "btn-check",
                              type: "radio",
                              name: 'radio' + filter.name,
                              ref_for: true,
                              ref: _ctx.filterRefs[filter.name],
                              id: filter.name + '-negValue',
                              onChange: ($event: any) => (
                  _ctx.changeCheckBoxValue(
                    $event,
                    filter.attributes.negValue,
                    filter.name
                  )
                ),
                              value: "3"
                            }, null, 40, _hoisted_13),
                            _createElementVNode("label", {
                              class: "btn filter-chip",
                              for: filter.name + '-negValue'
                            }, _toDisplayString(filter.attributes.negValue), 9, _hoisted_14)
                          ])
                        ])
                      ]))
                    : (filter.type == 'radioButtonWithStaticValues')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.attributes.values, (value, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("input", {
                                  class: "btn-check",
                                  type: "radio",
                                  name: 'radio' + filter.name,
                                  onChange: ($event: any) => (_ctx.changeRadioButtonStaticValue($event, null, filter.name)),
                                  ref_for: true,
                                  ref: _ctx.filterRefs[filter.name],
                                  checked: 
                  (_ctx.getFilterValues &&
                    _ctx.getFilterValues[filter.name] &&
                    _ctx.getFilterValues[filter.name].value === value) ||
                  (!_ctx.getFilterValues ||
                    !_ctx.getFilterValues[filter.name] ||
                    !_ctx.getFilterValues[filter.name].value) &&
                    index === 0
                ,
                                  id: filter.name + '-' + value,
                                  value: value
                                }, null, 40, _hoisted_17),
                                _createElementVNode("label", {
                                  class: "btn filter-chip",
                                  for: filter.name + '-'+value
                                }, _toDisplayString(value), 9, _hoisted_18)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (filter.type == 'date')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_Datepicker, {
                              "onUpdate:modelValue": ($event: any) => (_ctx.changeDateRangeValue($event, filter.name)),
                              clearable: true,
                              autoApply: true,
                              enableTimePicker: false,
                              startTime: _ctx.startTime,
                              dark: "",
                              "model-value": 
                _ctx.getFilterValues && _ctx.getFilterValues[filter.name]
                  ? _ctx.getFilterValues[filter.name].value
                  : null
              ,
                              locale: "en-US",
                              ref_for: true,
                              ref: _ctx.filterRefs[filter.name],
                              false: ""
                            }, null, 8, ["onUpdate:modelValue", "startTime", "model-value"])
                          ]))
                        : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-sm btn-white btn-active-light-primary me-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, " Reset "),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-sm btn-primary",
              "data-kt-menu-dismiss": "true",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, " Apply ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}